<template>
    <div :class="['page page--light', { 'page--embed': partnerAppEmbedCustomization, 'page--gradient-background': polls.length }]">
        <div :class="{ 'gradient-background': polls.length }">
            <div class="wrapper wrapper--no-max-width">
                <section class="polls">
                    <header :class="['row__header', { 'row__header--partner-app': isPartnerApp }]">
                        <back-button :isAbsolute="false"
                            :isBlack="true"
                            routeToHome
                        />

                        <h1>{{ title }}</h1>
                    </header>

                    <toggle-options v-if="toggleOptions.length"
                        :options.sync="toggleOptions"
                        @toggleOption="toggleStatus"
                    />

                    <div class="wrapper">
                        <div v-if="isInitialLoad"
                            class="polls__list"
                        >
                            <poll-tile-skeleton v-for="index in [1,2,3,4,5,6]"
                                :key="index"
                                :is-large="true"
                            />
                        </div>

                        <div v-else-if="polls.length"
                            class="polls__list"
                        >
                            <poll-tile v-for="(poll, index) in polls"
                                :key="index"
                                :poll="poll"
                                :is-large="true"
                                :partner="partner"
                            />
                        </div>

                        <div v-else
                            class="no-data"
                        >
                            {{ $t('global.poll.noPolls') }}
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <slot />
    </div>
</template>

<script>
// 3rd party
import {
    mapGetters,
} from 'vuex';

// Components
import backButton from '@webapp/components/back-button/back-button.vue';
import pollTile from '@webapp/components/poll/poll-tile.vue';
import pollTileSkeleton from '@webapp/components/poll/poll-tile-skeleton.vue';
import toggleOptions from '@webapp/components/status-toggle/status-toggle.vue';

export default {
    name: 'polls',
    components: {
        backButton,
        pollTile,
        pollTileSkeleton,
        toggleOptions,
    },
    props: {
        title: {
            type: String,
            default: '',
            required: true,
        },
        toggleOptions: {
            type: Array,
            default: () => ([]),
        },
        polls: {
            type: Array,
            default: () => ([]),
            required: true,
        },
        partner: {
            type: Object,
            default: () => ({}),
        },
        isInitialLoad: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters(['isPartnerApp', 'partnerAppEmbedCustomization']),
    },
    methods: {
        toggleStatus(options) {
            this.$emit('toggleOption', options);
        },
    },
};
</script>

<style lang="scss" scoped>
.gradient-background {
    height: 100%;
}

.polls {
    &__list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
}

.no-data {
    padding: 1.8rem;
}
</style>